import { Col, Row } from "react-bootstrap";
import styled from "styled-components";

export const ContentWrapper = styled(Row)``;

export const ContentBlockRow = styled(Row)`
`;
export const ContentBlockCol = styled(Col)`
`;

export const ContentHeader = styled.div`
    font-weight: bold;
    font-size: 1.25rem;
    padding: 1rem 0 0 1rem;
`